<template lang="html">
  <div class="footer">
    <hr>
    <Logout
      :isSignedIn="user.isSignedIn"
      :name="user.name"
      v-on:signed-out="$emit('signed-out',$event)">
    </Logout>
    <p>&copy; Copyright {{this.year}}<br>Gustav Corpas & Jacob Reggelsen</p>
  </div>
</template>

<script>
import Logout from './Logout.vue';

export default {

  name: 'Footer',
  props: {
    user: Object
  },
  data: function() {
    let date = new Date();
    return {
      year: date.getFullYear()
    }
  },
  components:{
    Logout
  }
}
</script>

<style lang="css" scoped>

  .footer {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    margin-bottom: 100px;
  }

</style>
